import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export function VisitorTracker() {
  const location = useLocation();
  useEffect(() => {
    let sid = localStorage.getItem("vp_visit");
    if (!sid) {
      sid = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random();
      localStorage.setItem("vp_visit", sid);
    }
    const ping = () =>
      api.post("/track", { session_id: sid, path: window.location.pathname }).catch(() => {});
    ping();
    const iv = setInterval(ping, 30000);
    return () => clearInterval(iv);
  }, [location.pathname]);
  return null;
}
